import { QueryModelCore } from "@/core/model.core";
import Browser from "@/core/browser";

export default class User {
  /**
   * 发送签证邮件
   * @param {String} spuNo 内部自动生成的产品编码
   * @param {Array<Number>} typeList 出行人类型列表
   * @param {String} email 需要发送的邮件地址
   */
  async sendVisaEmail(params) {
    const url = '/api-trade/task/sendQzEmail';
    const result = await new QueryModelCore(url).post({
      ...params,
      channel: Browser.ysfMiniprogram ? 2 : 1
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 更新签证订单基础信息
   * @param {String} tradeCode 订单编号(必填)
   */
  async uploadVisaOrderBaseInfo(params) {
    const url = '/api-trade/tradeApplet/updateQzBaseInfo';
    const result = await new QueryModelCore(url).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 填写寄送快递单号
   * @param {String} tradeCode 订单编号
   * @param {String} logistics 快递公司
   * @param {String} logisticsNo 快递单号
   */
  async fillExpressInfo(params) {
    const url = '/api-trade/tradeApplet/confirmDelivery';
    const result = await new QueryModelCore(url).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取签证办理进度
   * @param {String} tradeCode 订单编号
   */
  async progressInfo(tradeCode) {
    const url = '/api-trade/trade/queryVisaProgress';
    const result = await new QueryModelCore(url).get({ tradeCode });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取签证材料清单
   * @param {String} tradeCode 订单编号
   */
  async materialListByTradeCode(tradeCode) {
    const url = '/api-trade/tradeApplet/getMaterialList';
    const result = await new QueryModelCore(url).get({ tradeCode });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取签证订单预审材料
   * @param {String} tradeCode 订单编号
   */
  async auditMaterialInfo(tradeCode) {
    const url = '/api-trade/trade/queryAuditPreInfo';
    const result = await new QueryModelCore(url).get({ tradeCode });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 更新签证预审材料
   * @param {Number} type 操作类型 1-新增 2-删除
   * @param {String} tradeCode 订单编号
   * @param {Number} travellerId 出行人id
   * @param {Number} materialId 材料类型id
   * @param {Array} imageUrlList 图片集合
   */
  async uploadMaterial(params) {
    const url = '/api-trade/tradeApplet/uploadDocuments';
    const result = await new QueryModelCore(url).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 提交签证预审
   * @param {String} tradeCode 订单编号
   */
  async confirmAudit(tradeCode) {
    const url = '/api-trade/tradeApplet/auditConfirm';
    const result = await new QueryModelCore(url).post({ tradeCode });
    const { dataMap } = result;
    return dataMap;
  }
}